Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwitterMentionButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _generalObserver = require("../general-observer");
var _utils = require("./utils");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var TwitterMentionButton = function TwitterMentionButton(_ref) {
  var username = _ref.username,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleTwttrLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-testid": "twitter-mention-button",
    href: "https://twitter.com/intent/tweet?screen_name=".concat(username, "&ref_src=twsrc%5Etfw"),
    className: "twitter-mention-button twitter-mention-button-mdx-embed",
    "data-size": size
  }, "Tweet to @".concat(username)));
};
exports.TwitterMentionButton = TwitterMentionButton;